import { Partial } from '@40seas/entities/common';
import { InsuranceApplication } from './insurance-application.entity';

export class UpdateInsuranceApplicationDto extends Partial(InsuranceApplication) {}
